<template>
    <head>
        <meta charset="utf-8">
        <title>Contact Form</title>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta1/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-giJF6kkoqNQ00vy+HMDP7azOuL0xtbfIcaT9wjKHr8RbDVddVHyTfAAsrekwKmP1" crossorigin="anonymous">
    </head>
    <body>
    <h2>Contact Form</h2>
    <div class="container">
        <div class="row">
            <div class="col-xs-offset-4 col-xs-4" id="formarea">
                <form action="https://api.staticforms.xyz/submit" method="post">
                <div class="form-group">
                    <input type="text" class="form-control" name="name" placeholder="お名前" value="">
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" name="tel" placeholder="電話番号" value="">
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" name="email" placeholder="メールアドレス" value="">
                </div>
                <div class="form-group">
                    <textarea class="form-control" name="message" rows="5" placeholder="問い合わせ内容"></textarea>
                </div>
                <input type="hidden" name="accessKey" value="1f55a4cb-bc03-48f1-bba3-db39bce18320">
                <input type="hidden" name="subject" value="問い合わせが来ています">
                <input type="hidden" name="replyTo" value="@">
                <input type="hidden" name="redirectTo" value="http://masakijob.sakura.ne.jp/#/success">
                <div class="text-center">
                    <button type="submit" class="btn btn-primary mb-2">送信</button>
                </div>
                </form>
            </div>
        </div>
    </div>
    </body>
</template>

<script>
// バリデーションクリックイベント
</script>

<style scoped>
body {
    background: #f3f3f3;
}
.container {
    font-family: "Noto Sans JP";
    margin-top: 60px;
}
h1 {
    margin-bottom: 50px;
    text-align: center;
}
button {
    margin-top: 30px;
}
h2 {
  position: relative;
  padding: 1rem 2rem calc(1rem + 10px);
  background: #fff100;
}

h2:before {
  position: absolute;
  top: -7px;
  left: -7px;
  width: 100%;
  height: 100%;
  content: '';
  border: 4px solid #000;
}
</style>
